import { useAlertsStore } from "@/stores/alerts";

export const integrationWindow = async (url: string, onSuccess?: string, about = "_black") => {
  const userToast = useAlertsStore();
  const width = 1000;
  const height = 600;
  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;

  const w = window.open(url, about, `left=${left}, top=${top}, width=${width}, height=${height}`);
  return await new Promise<{
    close: Boolean;
    error: string;
    success: Boolean;
    resData?: Record<string, any>;
  }>((res) => {
    window.onmessage = async (e) => {
      if (e?.data?.sender !== "ptc_callback") {
        return;
      }
      if (e?.data?.close) {
        w?.close();
      }
      if (e?.data?.error) {
        userToast.addAlert("error", e.data.error, 7);
      }
      if (e?.data?.success && onSuccess) {
        userToast.addAlert("success", onSuccess, 7);
      }
      res({
        close: !!e?.data?.close,
        error: e?.data?.error as string,
        success: !!e?.data?.success,
        resData: e?.data?.resData
      });
    };

    const interval = setInterval(() => {
      if (w?.closed) {
        clearInterval(interval);
        res({
          close: true,
          error: "",
          success: false
        });
      }
    }, 100);
  });
};
